/* Maco · Avisame si vuelve — CRO-08 v4

   EL CTA ES EL COMPONENTE: un espacio, tres estados (cta -> captura -> listo).
   Cuando la variante no es comprable online, este CTA reemplaza al boton
   de carrito de esa superficie.

   COPY — REGLA CERRADA V1: siempre "si vuelve". Maco no promete reposicion.
   No hay condicional por metafield: se elimino por no tener owner operativo.

   Cambio de variante SIN polling:
     1) 'theme:variant:change' (burbujea a document, detail.variant trae
        id / title / available)
     2) MutationObserver sobre el atributo value de input[name="id"]
     3) change en cualquier options[...] (el theme usa "Talla" y "Tamano")

   NOTA: no usar this.slot: Element.slot es nativa y coacciona a string. */
(function () {
  'use strict';

  var KLAVIYO_REVISION = '2024-10-15';
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';

  /* Titulos de variante que NO son una talla mencionable.
     "TU" = talla unica en Maco: decir "la TU" es incorrecto. */
  var SIN_TALLA = /^(default title|tu|t\.?u\.?|talla [uú]nica|[uú]nica|u)$/i;

  function isEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function tallaLegible(t) {
    if (!t) return '';
    var s = String(t).trim();
    if (!s || SIN_TALLA.test(s)) return '';
    return s;
  }

  class MacoBis extends HTMLElement {
    constructor() {
      super();
      this.variantId = null;
      this.talla = '';
      this.step = 'cta';
      this.sending = false;
    }

    connectedCallback() {
      try {
        this.variants = JSON.parse(this.dataset.variants || '[]');
      } catch (e) {
        this.variants = [];
      }
      this.company = this.dataset.company;
      this.formId = this.dataset.formId;
      this.contexto = this.dataset.contexto || 'pdp';

      this.cta = this.querySelector('[data-bis-cta]');
      this.ctaText = this.querySelector('[data-bis-cta-text]');
      this.capture = this.querySelector('[data-bis-capture]');
      this.email = this.querySelector('[data-bis-email]');
      this.sendBtn = this.querySelector('[data-bis-send]');
      this.doneEl = this.querySelector('[data-bis-done]');
      this.doneText = this.querySelector('[data-bis-done-text]');
      this.note = this.querySelector('[data-bis-note]');
      this.msg = this.querySelector('[data-bis-msg]');
      this.host = this.parentElement;

      if (!this.cta || !this.sendBtn) return;

      this.cta.addEventListener('click', this.openCapture.bind(this));
      this.sendBtn.addEventListener('click', this.send.bind(this));
      this.email.addEventListener(
        'keydown',
        function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.send(e);
          }
        }.bind(this)
      );

      this.bindVariantSignals();
      this.apply(this.readVariantId());
    }

    disconnectedCallback() {
      if (this.mo) this.mo.disconnect();
      if (this.onThemeEvent) {
        document.removeEventListener('theme:variant:change', this.onThemeEvent);
      }
    }

    bindVariantSignals() {
      var self = this;

      this.onThemeEvent = function (e) {
        var v = e && e.detail && e.detail.variant;
        if (v && v.id != null) self.apply(String(v.id));
        else self.apply(self.readVariantId());
      };
      document.addEventListener('theme:variant:change', this.onThemeEvent);

      var input = this.idInput();
      if (input && window.MutationObserver) {
        this.mo = new MutationObserver(function () {
          self.apply(self.readVariantId());
        });
        this.mo.observe(input, { attributes: true, attributeFilter: ['value'] });
      }

      var wrapper = this.closest('[data-form-wrapper]') || document;
      wrapper.addEventListener('change', function (e) {
        var n = e.target && e.target.name;
        if (n && n.indexOf('options[') === 0) {
          setTimeout(function () {
            self.apply(self.readVariantId());
          }, 0);
        }
      });
    }

    idInput() {
      return (
        (this.formId &&
          document.querySelector('input[name="id"][form="' + this.formId + '"]')) ||
        (this.closest('[data-form-wrapper]') &&
          this.closest('[data-form-wrapper]').querySelector('input[name="id"]'))
      );
    }

    readVariantId() {
      var input = this.idInput();
      if (input && input.value) return String(input.value);
      var u = new URLSearchParams(window.location.search).get('variant');
      return u ? String(u) : null;
    }

    find(id) {
      for (var i = 0; i < this.variants.length; i++) {
        if (String(this.variants[i].id) === String(id)) return this.variants[i];
      }
      return null;
    }

    apply(id) {
      if (id === this.variantId) return;
      this.variantId = id;

      var v = this.find(id);
      var comprable = v ? v.a === true : true;
      this.talla = v ? tallaLegible(v.t) : '';

      if (comprable) {
        this.hidden = true;
        if (this.host && this.host.classList) {
          this.host.classList.remove('maco-bis-active');
        }
      } else {
        this.hidden = false;
        if (this.host && this.host.classList) {
          this.host.classList.add('maco-bis-active');
        }
      }
      this.go('cta');
    }

    laTalla() {
      return this.talla ? ' la ' + this.talla : '';
    }

    go(step) {
      this.step = step;
      this.sending = false;
      this.say('');
      if (this.sendBtn) this.sendBtn.disabled = false;

      var esCta = step === 'cta';
      var esCaptura = step === 'captura';
      var esListo = step === 'listo';

      this.cta.hidden = !esCta;
      this.capture.hidden = !esCaptura;
      this.doneEl.hidden = !esListo;
      this.note.hidden = !esCaptura;

      if (esCta) this.ctaText.textContent = 'Avísame si vuelve' + this.laTalla();
      if (esCaptura) this.note.textContent = 'Te avisamos si vuelve' + this.laTalla() + '.';
      if (esListo) this.doneText.textContent = 'Te avisamos si vuelve' + this.laTalla() + '.';
    }

    openCapture() {
      var h = this.cta.offsetHeight;
      if (h) this.email.style.height = h + 'px';
      this.go('captura');
      var el = this.email;
      if (el) setTimeout(function () { el.focus(); }, 60);
    }

    say(text, kind) {
      if (!this.msg) return;
      this.msg.textContent = text || '';
      this.msg.className = 'maco-bis__msg' + (kind ? ' maco-bis__msg--' + kind : '');
    }

    send(e) {
      if (e && e.preventDefault) e.preventDefault();
      if (this.sending) return;

      var email = ((this.email && this.email.value) || '').trim();
      if (!isEmail(email)) {
        this.say('Revisa tu correo, parece incompleto.', 'error');
        if (this.email) this.email.focus();
        return;
      }
      var variantId = this.variantId;
      if (!variantId) {
        this.say('Elige una talla primero.', 'error');
        return;
      }

      this.sending = true;
      this.sendBtn.disabled = true;
      this.say('');

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$custom:::$default:::' + variantId
              }
            }
          }
        }
      };

      var self = this;
      var talla = this.talla;
      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(this.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (r.ok || r.status === 202) {
            self.track(variantId, email, talla);
            self.go('listo');
          } else {
            return r.text().then(function (t) {
              throw new Error(r.status + ' ' + String(t).slice(0, 200));
            });
          }
        })
        .catch(function (err) {
          self.sending = false;
          self.sendBtn.disabled = false;
          self.say('No pudimos registrarte. Inténtalo de nuevo en un momento.', 'error');
          if (window.console) console.warn('[maco-bis]', err);
        });
    }

    track(variantId, email, talla) {
      try {
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(['identify', { $email: email }]);
        window.klaviyo.push([
          'track',
          'Maco BIS Subscribed',
          {
            VariantId: String(variantId),
            VariantName: talla || '',
            ProductName: this.dataset.productTitle || '',
            ProductID: this.dataset.productId || '',
            Contexto: this.contexto,
            Source: 'theme-maco-bis'
          }
        ]);
      } catch (e) {}
    }
  }

  if (!customElements.get('maco-bis')) {
    customElements.define('maco-bis', MacoBis);
  }
})();
